if (typeof module === 'object') {
    window.module = module;
    module = undefined;
}

if (!window.$ && window.jQuery) {
    window.$ = window.jQuery;
}